import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { OCmsProductTable } from '../components/organisme';
import { setCmsHead } from '../redux/head/headActions';
import { fetchProducts } from '../redux/product/productActions';
import { CMS_CONFIG } from '../config/cms.config';
import withAuthGuard from '../helpers/withAuthGuard';

const mapStateToProps = state => ({
	items: state.content.faq,
	isFetching: state.content.isFetching,
});

class AccessoiresOverviewPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: [],
			isFetching: true,
		};
	}

	componentDidMount() {
		const onClick = `${this.props.match.url}/create`;
		this.props.setCmsHead({ ...CMS_CONFIG.ACCESSOIRES.header.overview, onClick });

		this.bindHandles();
		this.props.fetchProducts();
	}

	componentWillReceiveProps(props) {
		for(let key in this.state) {// eslint-disable-line
			if (props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleSearch = this.handleSearch.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	handleSearch(value) {}
	handleEdit(id) {}
	handleDelete(id) {}

	render() {
		return (
			<div className="layout-cms--content-body layout-cms--content-body-grey">
				<OCmsProductTable
					columns={CMS_CONFIG.ACCESSOIRES.table.columns}
					items={this.state.items}
					isFetching={this.state.isFetching}
					onSearch={this.handleSearch}
					onEdit={this.handleEdit}
					onDelete={this.handleDelete}
				/>
			</div>
		);
	}
}

AccessoiresOverviewPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	fetchProducts: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	fetchProducts,
})(AccessoiresOverviewPage)));



// WEBPACK FOOTER //
// ./src/CMS/accessoires-overview.js